import _ from "underscore"
import messageResource from "../../messageResource"
import BaseReportFormatUtils from "../FormatUtils";
import {Feature, isEnabled} from "../../features/index"

export default class OvertimeReportFormatUtils extends BaseReportFormatUtils {
    static makePDFTitle(selectedParameters, andSubstitutionKey)
    {
        andSubstitutionKey = _.isUndefined(andSubstitutionKey) ? 'common_report.pdf.header.amp' : andSubstitutionKey;
        const andMessage = messageResource.getMessage(andSubstitutionKey);

        if (isEnabled(Feature.OVR))
            return messageResource.getMessage('overtime_report.pdf.header.time_balance_and_overtime', [andMessage]);

        return messageResource.getMessage('overtime_report.pdf.header.time_balance');
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/overtimeReport/FormatUtils.js